<script lang="ts">
  import Typography from "$lib/components/Typography/Typography.svelte";
  import { _ } from "svelte-i18n";
  import AccordionItem from "$lib/components/AccordionItem/AccordionItem.svelte";
  import { processInlineLinks } from "$lib/utils/url";

  let viewportWidth: number;
  let isMobile = false;
  let isTablet = false;
  let mdWidth = 768;
  let lgWidth = 1280;

  export let selectedType: string;

  $: isMobile = viewportWidth < mdWidth;

  $: isTablet = viewportWidth < lgWidth;

  export let howToMeasureInfo: { title: string; body: string }[];
  export let howToMeasureAdditionalInfo: string[] = [];
  export let image: string;

  let isAccessory = false;

  $: isAccessory =
    selectedType === $_("gloves") || selectedType === $_("belts");
</script>

<style lang="scss">
  .measuring-guide {
    width: 100%;

    @include breakpoint(md) {
    }
    &--image {
      width: 100%;
      display: flex;
      justify-content: center;
      @include breakpoint(md) {
        width: 50%;
      }

      @include breakpoint(lg) {
        width: 100%;
      }

      &__img {
        max-height: 870px;
        padding: 2rem;
      }

      &--table {
        table {
          border-right: 1px solid $background;
          border-spacing: 0;
          overflow-x: auto;
          width: 100%;

          th {
            border-bottom: 1px solid $background;
            text-align: start;
            height: 48px;

            padding: 0.5rem 2rem;

            background-color: $on-surface;
            @include breakpoint(md) {
              background-color: $background;
            }
            @include breakpoint(lg) {
              padding: 1rem 2rem;
            }
          }
        }
      }
    }

    &--image-column {
      @include breakpoint(md) {
        width: 100% !important;
      }
    }

    &--how-to-measure {
      padding: 2rem;
      @include breakpoint(lg) {
        padding: 0 10rem 0 4rem;
      }

      width: 100%;
      @include breakpoint(md) {
        width: 50%;
      }

      @include breakpoint(lg) {
        width: 100%;
      }

      &__title {
        padding: 2rem 0;
      }

      &__additional-info {
        padding-top: 16px;
      }
    }

    &--how-to-measure-column {
      @include breakpoint(md) {
        width: 100% !important;
      }
    }

    &--content {
      display: flex;

      flex-direction: column;
      @include breakpoint(md) {
        flex-direction: row-reverse;
      }
      @include breakpoint(lg) {
        flex-direction: column;
      }
    }

    &--content-column {
      @include breakpoint(md) {
        flex-direction: column-reverse !important;
      }
    }
  }

  :global(.accordion-item--header) {
    gap: 1rem;
    justify-content: flex-start;
  }
</style>

<svelte:window bind:innerWidth={viewportWidth} />

{#if selectedType !== $_("footwear")}
  <div class="measuring-guide">
    {#if isMobile}
      <div class="measuring-guide--image--table">
        <table>
          <tr>
            <th>
              <Typography
                component="span"
                variant="overline"
                theme={isMobile ? "inverse-on-surface" : "on-surface"}
                >{$_("Size measuring guide")}</Typography
              >
            </th>
          </tr>
        </table>
      </div>
    {/if}
    <div
      class={`measuring-guide--content ${
        isAccessory ? "measuring-guide--content-column" : ""
      }`}
    >
      <div
        class={`measuring-guide--image ${
          isAccessory ? "measuring-guide--image-column" : ""
        }`}
      >
        <img
          class="measuring-guide--image__img"
          src={image}
          alt={$_("sizeGuide.howToMeasure")}
          width="100%"
        />
      </div>
      <div
        class={`measuring-guide--how-to-measure ${
          isAccessory ? "measuring-guide--how-to-measure-column" : ""
        }`}
      >
        {#if !isMobile && selectedType !== $_("belts") && selectedType !== $_("gloves") && howToMeasureInfo.length > 0}
          <div class="measuring-guide--how-to-measure__title">
            <Typography variant="button1" component="span" underline>
              {$_("How to measure")}
            </Typography>
          </div>
        {/if}

        {#if selectedType === $_("belts")}
          {#each howToMeasureAdditionalInfo as additionalInfo}
            <div class="measuring-guide--how-to-measure__additional-info">
              <Typography variant="body1" component="p">
                {additionalInfo}
              </Typography>
            </div>
          {/each}
        {/if}

        {#each howToMeasureInfo as { title, body }, index}
          <AccordionItem
            title={title && `${index + 1}. ${title}`}
            innerBorder={false}
            accordionOpen={isMobile || isTablet || isAccessory}
          >
            <div>
              <Typography variant="body1-alt" component="p">
                {@html processInlineLinks(body)}
              </Typography>
            </div>
          </AccordionItem>
        {/each}
      </div>
    </div>
  </div>
{/if}
